import {Fade, Modal} from '@material-ui/core';
import React from 'react';
import './RoundRectangleModal.scss';

const RoundRectangleModal = ({
    isOpen,
    body,
    showCloseIcon,
    handleOnClose,
    className,
    }) => {
    return (
        <Modal open={isOpen} onClose={handleOnClose} closeAfterTransition>
            <Fade in={isOpen} timeout={300}>
                <div className={'content-container '+className}>
                    <div className={'title'}>
                        {showCloseIcon && <button className="btn-close" onClick={handleOnClose}>X</button>}
                    </div>
                    <div className={'content'}>{body}</div>
                </div>
            </Fade>
        </Modal>
    );
};

export default RoundRectangleModal;
